import { SmsUsaRegistration, TextMessagingConfiguration } from '@mews-commander/data-access';
import { Stack } from '@optimus-web/core';
import { MessagingRegistration } from './MessagingRegistration/MessagingRegistration';
import { GeneralConfiguration } from './GeneralConfiguration';

interface GeneralTabProps {
    configuration: TextMessagingConfiguration;
    enterpriseId: string;
    smsUsaRegistration: SmsUsaRegistration | null | undefined;
}

export const GeneralTab = ({ configuration, enterpriseId, smsUsaRegistration }: GeneralTabProps) => (
    <Stack vertical spacing="400">
        <GeneralConfiguration configuration={configuration} enterpriseId={enterpriseId} />
        {smsUsaRegistration != null ? (
            <MessagingRegistration enterpriseId={enterpriseId} smsUsaRegistration={smsUsaRegistration} />
        ) : null}
    </Stack>
);
